const acceptedInputTypes = {
  normal: {
    htmlType: "text",
    max: 150
  },
  rut: {
    htmlType: "text",
    max: 12
  },
  serial_number: {
    htmlType: "text",
    max: 10,
    autoComplete: "off"
  },
  phone: {
    htmlType: "number",
    max: 9
  },
  email: {
    htmlType: "email",
    max: 150
  },
  password: {
    htmlType: "password",
    max: 150,
    autoComplete: "off"
  },
  number: {
    htmlType: "number",
    max: 100
  }
};

const TYPES = () => {
  let enumerator = {};
  Object.keys(acceptedInputTypes).forEach(t => (enumerator[t] = t));
  return enumerator;
};

export { acceptedInputTypes, TYPES };
